import heroImage from "../images/hero.jpg";
import twelfthNightImage from "../images/twelfth_night.jpg"; 
import comedyErrorImage from "../images/comedy_errors.jpg"; 
import twilightTimeImage from "../images/twilight_time.jpg"; 
import littleWomenImage from "../images/little_women.jpg"; 
import midsummerImage from "../images/midsummer.jpeg"; 
import addamsFamilyImage from "../images/addams_family.jpg"; 

const directingData = [
  {
    title: "Twelth Night - Theatre Hunstville - 2026",
    role: "Director",
    images: [
      twelfthNightImage
    ],
    description: `Shakespeare meets the 2000s in this fresh, fast-paced take on Twelfth Night!
    Shipwrecked and stranded in a world of pop music, flip phones, and Y2K fashion, Viola disguises herself as a man, only to find herself tangled in a love triangle full of mistaken identities, outrageous antics, and hilarious hijinks. With all the wit, romance, and revelry of Shakespeare’s original, this modern adaptation brings the comedy to a new millennium.`,
    links: [
      {
        url: "https://www.theatrehsv.org/",
        text: "Theatre Huntsville"
      }
    ]
  },
  {
    title: "The Comedy of Errors - Huntsville Shakespeare Festival - 2025",
    role: "Director",
    images: [
      comedyErrorImage
    ],
    description: 'The reimagining of The Comedy of Errors is set in a modern-day music festival, where flashing lights, packed crowds, backstage chaos, and nonstop performances create the perfect setting for mistaken identities and comic confusion. As separated twins unknowingly cross paths amid backstage workers, artist tents, and eager fans, the festival spirals into hilarious disorder, celebrating connection, spectacle, and the joyful unpredictability of life.',
    links: [
      {
        url: "https://www.uah.edu/ahs/departments/theatre-film/huntsville-shakespeare/current-season",
        text: "Huntsville Shakespeare Festival"
      }
    ]
  },
  {
    title: "Twilight Time - NEMCC - 2025",
    role: "Director",
    images: [
      twilightTimeImage
    ],
    description: `Two strangers contemplating suicide meet on a park bench. After learning of their common purpose, they discover a mutual love of junk food, horror movies, and politics. Will that be enough to overcome their wish to self-destruct?`,
    links: [
      {
        url: "https://www.nemcc.edu/fine-arts/",
        text: "Northeast Mississippi Community College Theater Dept."
      },
      {
        url: "https://johndoble.com/",
        text: "Author: John Doble"
      }
    ]
  },
  {
    title: "The Drowsy Chaperone - St. John Paul II HS - 2021",
    role: "Co-Director",
    images: [
      heroImage
    ],
    description: "Description here.",
    links: [
      {
        url: "https://jp2falcons.org/drama",
        text: "St. John Paul II Catholic High School Drama Dept."
      }
    ]
  },
  {
    title: "Little Women - St. John Paul II HS - 2019",
    role: "Co-Director",
    images: [
      littleWomenImage
    ],
    description: `Based on Louisa May Alcott's life, Little Women follows the adventures of sisters Jo, Meg, Beth, and Amy March. Jo is trying to sell her stories for publication, but the publishers are not interested – her friend, Professor Bhaer, tells her that she has to do better and write more from herself. Begrudgingly taking this advice, Jo weaves the story of herself and her sisters and their experience growing up in Civil War America.`,
    links: [
      {
        url: "https://www.instagram.com/jpiifalcontheatre/",
        text: "St. John Paul II Catholic High School Drama Dept."
      }
    ]
  },
  {
    title: "A Midsummer Night's Dream - St. John Paul II HS - 2018",
    role: "Director",
    images: [
      midsummerImage
    ],
    description: 'A comedy about four young Athenian lovers, a troupe of amateur actors, and a group of mischievous fairies who become entangled in a night of magical mischief, mistaken identities, and shifting romances in an enchanted forest.',
    links: [
      {
        url: "https://www.instagram.com/jpiifalcontheatre/",
        text: "St. John Paul II Catholic High School Drama Dept."
      }
    ]
  },
  {
    title: "The Addams Family - St. John Paul II HS - 2018",
    role: "Co-Director",
    images: [
      addamsFamilyImage
    ],
    description: `This show follows Wednesday Addams, the ultimate princess of darkness, who has fallen in love with a sweet, "normal" young man from Ohio. Chaos ensues when the two contrasting families meet for a fateful dinner, forcing Gomez Addams to keep a secret from his beloved wife, Morticia.`,
    links: [
      {
        url: "https://www.instagram.com/jpiifalcontheatre/",
        text: "St. John Paul II Catholic High School Drama Dept."
      }
    ]
  }
];

export default directingData;

// {
//     title: "Title",
//     role: "Role",
//     images: [
//       heroImage
//     ],
//     description: "Description",
//     credits: "credits",
//     links: [
//       {
//         url: "https://www.theatrehsv.org/",
//         text: "Theatre Huntsville"
//       },
//       {
//         url: "https://www.theatrehsv.org/",
//         text: "Theatre Huntsville"
//       }
//     ]
//   }